export default "__VITE_ASSET__CbO_aDI___"